import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Public, lightweight legal page used for both Privacy Policy and Terms.
 * Renders without auth so Google Play Console can scrape the page during
 * app review. Heading + body are passed in by the parent page wrapper.
 */
export const LegalPage = ({ title, lastUpdated, children }) => (
  <div className="min-h-screen bg-[#f7f3e8] text-[#2a2520]">
    <header className="border-b border-[#e6dfd0] bg-[#ba7233] text-[#f7f3e8]">
      <div className="max-w-3xl mx-auto px-6 py-5 flex items-center justify-between">
        <Link to="/" className="font-bold tracking-wide text-lg" data-testid="legal-home-link">
          Clayworks
        </Link>
        <Link to="/" className="text-sm underline-offset-4 hover:underline opacity-90">
          Back to app
        </Link>
      </div>
    </header>
    <main className="max-w-3xl mx-auto px-6 py-12">
      <h1 className="text-3xl sm:text-4xl font-semibold mb-3">{title}</h1>
      <p className="text-xs text-[#7d7468] mb-8">Last updated: {lastUpdated}</p>
      <article className="prose prose-stone max-w-none [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:mt-8 [&_h2]:mb-3 [&_p]:leading-relaxed [&_p]:mb-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-4 [&_li]:mb-1">
        {children}
      </article>
    </main>
    <footer className="border-t border-[#e6dfd0] py-6 text-center text-xs text-[#7d7468]">
      © {new Date().getFullYear()} Clayworks Spaces Technologies Pvt Ltd · <Link to="/privacy" className="underline">Privacy</Link> · <Link to="/terms" className="underline">Terms</Link>
    </footer>
  </div>
);

export default LegalPage;
